import React from 'react'
import { Typography } from 'antd'
import { TextProps } from 'antd/lib/typography/Text'
import { BlockProps } from 'antd/lib/typography/Base'

import { useT } from 'src/core/hooks/use-translation'

// ANT does not export
declare const TITLE_ELE_LIST: [1, 2, 3, 4]
declare type TitleProps = Omit<
  BlockProps & {
    level?: typeof TITLE_ELE_LIST[number]
  },
  'strong'
>

function Text({
  children,
  code,
  colon = false,
  onlyText = false,
  title,
  ...props
}: TextProps & {
  colon?: boolean
  title?: string
  onlyText?: boolean
}) {
  const { t } = useT()

  if (onlyText) {
    return <>{t(title)}</>
  }

  return (
    <Typography.Text code={code} {...props}>
      {code ? title : t(title)}
      {colon && ': '}
      {children}
    </Typography.Text>
  )
}

function Title({ title, children, ...props }: TitleProps & { title?: string }) {
  const { t } = useT()
  return (
    <Typography.Title {...props}>
      {t(title)}
      {children}
    </Typography.Title>
  )
}

export { Text, Title }
